const THEME_JOB_STORAGE_KEY = 'craftmyparty_inflight_theme_job';
const PLAN_JOB_STORAGE_KEY = 'craftmyparty_inflight_plan_job';
const PENDING_THEME_JOB_START_KEY = 'craftmyparty_pending_theme_job_start';
const PENDING_PLAN_JOB_START_KEY = 'craftmyparty_pending_plan_job_start';
const PENDING_THEME_JOB_START_TTL_MS = 15000;
const PENDING_PLAN_JOB_START_TTL_MS = 15000;

const readJson = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

const writeJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (_) {}
};

const removeJson = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (_) {}
};

export const saveInFlightThemeJob = (snapshot) => writeJson(THEME_JOB_STORAGE_KEY, snapshot);
export const getInFlightThemeJob = () => readJson(THEME_JOB_STORAGE_KEY);
export const clearInFlightThemeJob = () => removeJson(THEME_JOB_STORAGE_KEY);

export const savePendingThemeJobStart = (snapshot) => writeJson(PENDING_THEME_JOB_START_KEY, {
  ...snapshot,
  createdAt: snapshot?.createdAt || Date.now()
});

export const getPendingThemeJobStart = () => {
  const snapshot = readJson(PENDING_THEME_JOB_START_KEY);
  if (!snapshot?.eventDataKey) return null;
  if (Date.now() - Number(snapshot.createdAt || 0) > PENDING_THEME_JOB_START_TTL_MS) {
    removeJson(PENDING_THEME_JOB_START_KEY);
    return null;
  }
  return snapshot;
};

export const clearPendingThemeJobStart = (eventDataKey = null) => {
  if (!eventDataKey) {
    removeJson(PENDING_THEME_JOB_START_KEY);
    return;
  }
  const snapshot = readJson(PENDING_THEME_JOB_START_KEY);
  if (!snapshot || snapshot.eventDataKey === eventDataKey) {
    removeJson(PENDING_THEME_JOB_START_KEY);
  }
};

export const saveInFlightPlanJob = (snapshot) => writeJson(PLAN_JOB_STORAGE_KEY, snapshot);
export const getInFlightPlanJob = () => readJson(PLAN_JOB_STORAGE_KEY);
export const clearInFlightPlanJob = () => removeJson(PLAN_JOB_STORAGE_KEY);

export const savePendingPlanJobStart = (snapshot) => writeJson(PENDING_PLAN_JOB_START_KEY, {
  ...snapshot,
  createdAt: snapshot?.createdAt || Date.now()
});

export const getPendingPlanJobStart = () => {
  const snapshot = readJson(PENDING_PLAN_JOB_START_KEY);
  if (!snapshot?.requestKey) return null;
  if (Date.now() - Number(snapshot.createdAt || 0) > PENDING_PLAN_JOB_START_TTL_MS) {
    removeJson(PENDING_PLAN_JOB_START_KEY);
    return null;
  }
  return snapshot;
};

export const clearPendingPlanJobStart = (requestKey = null) => {
  if (!requestKey) {
    removeJson(PENDING_PLAN_JOB_START_KEY);
    return;
  }
  const snapshot = readJson(PENDING_PLAN_JOB_START_KEY);
  if (!snapshot || snapshot.requestKey === requestKey) {
    removeJson(PENDING_PLAN_JOB_START_KEY);
  }
};
